module.exports = __webpack_public_path__ + "img/informate.ff6ff3b9.png";